import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "Sous quel délai répondez-vous à une demande de devis ?",
    a: "Nous revenons vers vous sous 48 heures ouvrées avec une proposition détaillée. Pour les chantiers urgents, contactez-nous directement par téléphone : nous nous adaptons.",
  },
  {
    q: "Êtes-vous assurés ?",
    a: "Oui. Akay dispose d'une assurance responsabilité civile professionnelle complète. Tous nos collaborateurs sont déclarés et formés.",
  },
  {
    q: "Quels produits utilisez-vous ?",
    a: "Nous privilégions des produits écolabel et des microfibres réutilisables. Pour les chantiers, nous adaptons les produits aux supports (parquet, vitres, pierre naturelle, etc.).",
  },
  {
    q: "Pouvez-vous intervenir en dehors des heures de bureau ?",
    a: "Bien sûr. Nous intervenons tôt le matin, tard le soir ou le week-end pour ne pas perturber vos activités. Le planning est défini avec vous.",
  },
  {
    q: "Quelle est votre zone d'intervention ?",
    a: "Nous couvrons les provinces de Liège et du Limbourg. Si vous êtes à proximité, contactez-nous, nous étudions votre demande.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="section-pad">
      <div className="grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5">
          <div className="eyebrow mb-6">Questions fréquentes</div>
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-light leading-[1]">
            Tout ce que<br />
            vous voulez<br />
            <span className="italic text-[hsl(var(--accent))]">savoir</span>.
          </h2>
        </div>
        <div className="lg:col-span-7">
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {faqs.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-b border-border"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="text-left text-base lg:text-lg py-6 hover:text-[hsl(var(--accent))] hover:no-underline">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground leading-relaxed pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
